import { CenteringDiv, FlexRowDiv, H1, FlexDiv } from 'components/generic/HomePageComponents'
import { DarkButton, FeaturedProfilesImage } from './Styled'
import ProfileCardsContainer from './ProfileCardsContainer'
import ProfileCard from './ProfileCard'

const FeaturedProfiles = ({
  listings,
  featuredProvidersHeader,
  featuredProvidersCta,
  featuredProvidersCtaLink,
  imageURL,
}) => (
  <FlexRowDiv bg='#FBFBFB' flexWrap='wrap'>
    <CenteringDiv>
      <H1
        textAlign={['center', 'center', 'left']}
        ml='10px'
        mr='10px'
        fontSize={['25px', '25px', '25px', '45px']}
      >
        {featuredProvidersHeader}
      </H1>

      <ProfileCardsContainer>
        <ProfileCard card={listings[0]} />
        <ProfileCard card={listings[1]} display={['none', 'none', 'inline']} />
        <ProfileCard card={listings[2]} display={['none', 'none', 'inline']} />
      </ProfileCardsContainer>
      <DarkButton
        whiteSpace='nowrap'
        mt='35px'
        padding={['13px 28px', '13px 38px', '13px 48px']}
        maxWidth={['325px', '415px']}
        fontSize={['18px', '18px', '18px', '25px']}
        href={featuredProvidersCtaLink}
        rel='nofollow'
      >
        {featuredProvidersCta}
      </DarkButton>
    </CenteringDiv>
    <FlexDiv flexBasis='100%'>
      <FeaturedProfilesImage
        src={imageURL}
        height={['0px', '0px', '150px', '164px']}
        display={['none', 'none', 'inline', 'inline']}
        alt='Featured Profiles'
      />
    </FlexDiv>
  </FlexRowDiv>
)

export default FeaturedProfiles
